import api from './axiosConfig';
import { LocationLogDto, LocationReportDto, SaveLocationRequest } from '../types';

export const geoLocationApi = {
  saveLocation: async (data: SaveLocationRequest): Promise<{ id: string }> => {
    const response = await api.post<{ id: string }>('/geolocation/save', data);
    return response.data;
  },

  getLocationHistory: async (
    employeeId: string,
    startDate: string,
    endDate: string
  ): Promise<LocationLogDto[]> => {
    const response = await api.get<LocationLogDto[]>('/geolocation/history', {
      params: { employeeId, startDate, endDate },
    });
    return response.data;
  },

  getLocationReport: async (
    employeeIds: string[],
    startDate: string,
    endDate: string
  ): Promise<LocationReportDto[]> => {
    const params = new URLSearchParams();
    employeeIds.forEach(id => params.append('employeeIds', id));
    params.append('startDate', startDate);
    params.append('endDate', endDate);
    const response = await api.get<LocationReportDto[]>('/geolocation/report', { params });
    return response.data;
  },
};
